import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    schoolYears: [],
    schoolTypes: [],
    isLoading: false,
    gridYear: '',
    gridSchools: '',
    gridSchoolsList: [],
    gridRevision: 0,
    gridSettingsLoaded: false,
    listLoadedAt: {
        parents: null,
        students: null,
        schoolPayments: null,
        schoolCharges: null,
        schoolRecPayments: null,
        schoolRecCharges: null,
        hub: null,
    },
};

const schoolSlice = createSlice({
    name: "school",
    initialState,
    reducers: {
        loadSchoolYears(state, action) {
            state.schoolYears = action.payload.schoolYears || [];
        },
        loadSchoolTypes(state, action) {
            state.schoolTypes = action.payload.schoolTypes || [];
        },
        setIsLoading(state, action) {
            state.isLoading = action.payload;
        },
        loadGridContext(state, action) {
            state.gridYear = action.payload.year || '';
            state.gridSchools = action.payload.schools || '';
            state.gridSchoolsList = action.payload.schoolsList || [];
            state.gridSettingsLoaded = true;
        },
        setGridYear(state, action) {
            state.gridYear = action.payload || '';
        },
        setGridSchools(state, action) {
            state.gridSchools = action.payload || '';
        },
        bumpGridRevision(state) {
            state.gridRevision += 1;
        },
        noteListLoaded(state, action) {
            const list = action.payload.list
            if (Object.prototype.hasOwnProperty.call(state.listLoadedAt, list)) {
                state.listLoadedAt[list] = action.payload.revision
            }
        },
        resetState: () => initialState,
    },
});

export const schoolActions = schoolSlice.actions;
export default schoolSlice;


